<template>
  <div class="toggle--container" @click="$emit('click')">
    <span :class="['toggle--button', on ? 'on' : 'off']">
      <span class="toggle--circle"></span>
    </span>
  </div>
</template>

<script>
export default {
  name: "ToggleButton",
  props: {
    on: Boolean
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.toggle--container,
.toggle--container * {
  box-sizing: border-box;
}

.toggle--container {
  display: inline-block;
  height: 1.5rem;
  width: 3rem;
  vertical-align: middle;
}

.toggle--button {
  outline: 0;
  display: block;
  width: 100%;
  height: 100%;
  position: relative;
  cursor: pointer;
  user-select: none;
  background: #d5d5d5;
  border-radius: 2rem;
  padding: 2px;
  transition: all 0.5s ease;
}

.toggle--circle {
  position: relative;
  display: block;
  content: "";
  width: 1.25rem;
  margin-left: -1.25rem; // match circle width
  height: 100%;
  border-radius: 50%;
  background: #fff;
  transition: all 0.5s ease; // slower?
  left: 1.25rem;
}

.toggle--input {
  display: none;
}

.toggle--button.on .toggle--circle {
  left: 100%;
}

.toggle--button.on {
  background: #c41230;
}
</style>
